export enum English {
  noData = 'No data',
}
